module.exports = __webpack_public_path__ + "img/ic_check.b200d89d.png";